var _path, _rect, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5835 3.63333C4.5835 2.63922 5.38938 1.83333 6.3835 1.83333H15.6168C16.6109 1.83333 17.4168 2.63922 17.4168 3.63333V19.25H12.3752V16.4833C12.3752 15.9863 11.9722 15.5833 11.4752 15.5833H10.5252C10.0281 15.5833 9.62516 15.9863 9.62516 16.4833V19.25H4.5835V3.63333ZM7.3335 4.56667C7.3335 4.06961 7.73644 3.66667 8.2335 3.66667H9.1835C9.68055 3.66667 10.0835 4.06961 10.0835 4.56667V5.51667C10.0835 6.01372 9.68055 6.41667 9.1835 6.41667H8.2335C7.73644 6.41667 7.3335 6.01372 7.3335 5.51667V4.56667ZM12.8168 3.66667C12.3198 3.66667 11.9168 4.06961 11.9168 4.56667V5.51667C11.9168 6.01372 12.3198 6.41667 12.8168 6.41667H13.7668C14.2639 6.41667 14.6668 6.01372 14.6668 5.51667V4.56667C14.6668 4.06961 14.2639 3.66667 13.7668 3.66667H12.8168ZM7.3335 8.23333C7.3335 7.73628 7.73644 7.33333 8.2335 7.33333H9.1835C9.68055 7.33333 10.0835 7.73628 10.0835 8.23333V9.18333C10.0835 9.68039 9.68055 10.0833 9.1835 10.0833H8.2335C7.73644 10.0833 7.3335 9.68039 7.3335 9.18333V8.23333ZM8.2335 11C7.73644 11 7.3335 11.4029 7.3335 11.9V12.85C7.3335 13.3471 7.73644 13.75 8.2335 13.75H9.1835C9.68055 13.75 10.0835 13.3471 10.0835 12.85V11.9C10.0835 11.4029 9.68055 11 9.1835 11H8.2335ZM11.9168 11.9C11.9168 11.4029 12.3198 11 12.8168 11H13.7668C14.2639 11 14.6668 11.4029 14.6668 11.9V12.85C14.6668 13.3471 14.2639 13.75 13.7668 13.75H12.8168C12.3198 13.75 11.9168 13.3471 11.9168 12.85V11.9Z",
    fill: "#6C757D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9165,
    y: 7.33333,
    width: 2.75,
    height: 2.75,
    rx: 0.9,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.75 21.0724C2.75 20.0659 3.56592 19.25 4.5724 19.25H17.4276C18.4341 19.25 19.25 20.0659 19.25 21.0724C19.25 21.0784 19.2451 21.0833 19.2391 21.0833H2.76094C2.7549 21.0833 2.75 21.0784 2.75 21.0724Z",
    fill: "#6C757D"
  })));
}

export default SvgComponyIcon;